<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                    ></el-cascader>
                    <div class="search-name">业务员</div>
                    <el-select v-model="searchData.StaffId" size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">时间</div>
                    <el-date-picker v-model="searchData.Date" type="month" size="small" class="search-name" placeholder="选择月"></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" icon="el-icon-magic-stick" type="warning" class="search-btn" @click="getTableData">生成报表</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableSaleData" border="" style="width: 100%">
                    <el-table-column show-overflow-tooltip width="100px" prop="SName" label="姓名" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="SaleTotalAmount" label="出勤天数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="SaleOrderTotalCount" label="工作时长（分钟）"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="SaleOrderTotalCount" label="迟到次数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="GoodsTotalCount" label="迟到时长"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" prop="SaleReturnTotalAmount" label="上班缺卡次数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" prop="SaleReturnTotalCount" label="下班缺卡次数"></el-table-column>
                    <el-table-column label="考勤结果">
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="1"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="2"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="3"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="4"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="5"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="六"></el-table-column>
                        <el-table-column show-overflow-tooltip width="80" prop="CusTotalCount" label="日"></el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: '',
            dateFTimes: '',
            orgSearchData: [],
            searchData: {
                OrgId: '',
                StaffId: '',
                Date: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1).toString(),
                page: 1,
                limit: 15
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tablePurchaseData: [],
            tablePurchaseDataLength: 0
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    methods: {
        // 重置表单
        resetSearch() {
            this.$refs.orgCascader.$refs.panel.clearCheckedNodes();
            this.searchData.OrgId = '';
            this.searchData.StaffId = '';
            this.searchData.Date = new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1).toString();
            this.searchData.page = 1;
            this.searchData.limit = 15;
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetSignMonthStatList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableSaleData = data;
                    this.tableSaleDataLength = res.count;
                })
                .catch(() => {});
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        }
    }
};
</script>
